import {
    DEFAULT_MONITORING_PERIOD_DAYS,
    DEFAULT_NOTIFICATION_THRESHOLDS,
} from 'modules/settings/components/custom-notifications/custom-notification-form.constants';
import {
    CustomAlarmFormMode,
    CustomAlarmFormState,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.model';

export const CUSTOM_ALARM_FORM_HEADER_TEXTS: Record<CustomAlarmFormMode, string> = {
    add: 'settings.devices.custom-alarms.create.form.title',
    edit: 'settings.devices.custom-alarms.edit.form.title',
};

export const CUSTOM_ALARMS_FORM_DEFAULT_FORM: CustomAlarmFormState = {
    name: '',
    eventDraftIds: [],
    selectedEventIds: [],
    windowDays: DEFAULT_MONITORING_PERIOD_DAYS,
    notifications: DEFAULT_NOTIFICATION_THRESHOLDS,
    isResettable: false,
    requiresCommentOnReset: false,
};

export const CUSTOM_ALARM_FORM_SUBMIT_TEXTS: Record<CustomAlarmFormMode, string> = {
    add: 'settings.devices.custom-alarms.create.modal.actions.submit',
    edit: 'settings.devices.custom-alarms.edit.modal.save',
};

export const CUSTOM_ALARM_OPTIONAL_SETTINGS_TEXTS = {
    title: 'settings.devices.custom-alarms.create.modal.optional.title',
    resetTitle: 'settings.devices.custom-alarms.create.modal.optional.reset.title',
    resetHint: 'settings.devices.custom-alarms.create.modal.optional.reset.hint',
    commentTitle: 'settings.devices.custom-alarms.create.modal.optional.comment.title',
    commentHint: 'settings.devices.custom-alarms.create.modal.optional.comment.hint',
};
